(function ($) {

    $('#posts').masonry({
        columnWidth: 300,
        itemSelector: '.post-item',
        gutter: 30,
        fitWidth: true
    });

})(jQuery);